import { centsToDollars, parsePrice } from "helpers/price";

import {
  StyledProceduresListContainer,
  StyledProcedureContainer,
  StyledProcedureItem,
} from "../../styled";

export default function ProceduresList({
  procedures,
}: {
  procedures: {
    cptCode: string;
    cptDescription: string;
    amount: number;
  }[];
}) {
  return (
    <StyledProceduresListContainer>
      <i
        className="pi pi-info-circle text-lg purple"
        style={{ paddingTop: "2px" }}
      />
      <div className="flex flex-column gap-1">
        <p className="text-sm font-semibold dark-gray mb-2">
          The following procedure(s) may not be covered by your insurance and
          could result in additional costs
        </p>
        <StyledProcedureContainer>
          {procedures.map((procedure) => (
            <StyledProcedureItem key={procedure.cptCode}>
              <p className="text-sm font-semibold dark-gray">
                {procedure.cptDescription}
              </p>
              <p className="text-sm font-bold dark-gray">
                {parsePrice(centsToDollars(procedure.amount))}
              </p>
            </StyledProcedureItem>
          ))}
          <p className="text-xs font-normal purple">
            Reason: Medicare does not consider procedure(s) listed above
            medically necessary for your condition
          </p>
        </StyledProcedureContainer>
      </div>
    </StyledProceduresListContainer>
  );
}
